import { render } from "./Donate.vue?vue&type=template&id=642003aa&scoped=true"
import script from "./Donate.vue?vue&type=script&lang=js"
export * from "./Donate.vue?vue&type=script&lang=js"

import "./Donate.vue?vue&type=style&index=0&id=642003aa&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-642003aa"

export default script